import { ButtonGroup } from "@transfr-inc/dashboard-components/forms";
import PropTypes from "prop-types";
import { useState } from "react";

import {
  InstitutionList,
  SectionWithHeading,
} from "@features/post-high-school/components";

export const ProgramsSection = ({ careerId, onInstitutionClick }) => {
  const [showBestMatch, setShowBestMatch] = useState(true);

  return (
    <>
      <SectionWithHeading
        heading="Programs"
        className="post-high-school-programs-section"
      >
        <div className="post-high-school-button-group">
          <ButtonGroup
            role="radiogroup"
            buttons={[
              {
                label: "Best Match",
                id: 1,
                props: {
                  role: "radio",
                  "aria-label": "Best matches from nearby institutions",
                },
                onClick: () => setShowBestMatch(true),
              },
              {
                label: "Nearby",
                id: 2,
                props: {
                  role: "radio",
                  "aria-label": "Nearby institutions",
                },
                onClick: () => setShowBestMatch(false),
              },
            ]}
            selected={showBestMatch ? 1 : 2}
          />
        </div>
      </SectionWithHeading>
      <InstitutionList
        careerId={careerId}
        isRelevantToCareer={showBestMatch}
        onInstitutionClick={onInstitutionClick}
      />
    </>
  );
};

ProgramsSection.propTypes = {
  careerId: PropTypes.number,
  onInstitutionClick: PropTypes.func,
};
